exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bloc-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%; }\n\n.ml-10px {\n  margin-left: 10px; }\n\n.ml-20px {\n  margin-left: 20px; }\n\n.error {\n  color: red; }\n\n.success {\n  color: green; }\n\n.my-1 {\n  margin-top: 1em;\n  margin-bottom: 1em; }\n\n.d-flex {\n  display: flex; }\n\n.modalContainer .title {\n  font-size: 1.3em; }\n\n.modalContainer .popUpContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/component/page/local-authority-list-page/style.scss
// module id = 828
// module chunks = 0